"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// tslint:disable:deprecation
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var Icons_1 = require("../icons/Icons");
var SharedWidgets_1 = require("../SharedWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var Date_1 = require("../utils/Date");
var DomUtil_1 = require("../utils/DomUtil");
var Overlay_1 = require("../utils/Overlay");
var DatePickerWidget_1 = require("./DatePicker/DatePickerWidget");
var DomWidgets_1 = require("./DomWidgets");
var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["ShortDateTime"] = 0] = "ShortDateTime";
    DateFormat[DateFormat["MediumDateTime"] = 1] = "MediumDateTime";
    DateFormat[DateFormat["LongDateTime"] = 2] = "LongDateTime";
    DateFormat[DateFormat["FullDateTime"] = 3] = "FullDateTime";
    DateFormat[DateFormat["ShortDate"] = 4] = "ShortDate";
    DateFormat[DateFormat["MediumDate"] = 5] = "MediumDate";
    DateFormat[DateFormat["LongDate"] = 6] = "LongDate";
    DateFormat[DateFormat["FullDate"] = 7] = "FullDate";
    DateFormat[DateFormat["ShortDateWithFullYear"] = 8] = "ShortDateWithFullYear";
    DateFormat[DateFormat["ShortDateTimeWithFullYear"] = 9] = "ShortDateTimeWithFullYear";
    DateFormat[DateFormat["ShortDateTimeWithFullYear24Hour"] = 10] = "ShortDateTimeWithFullYear24Hour";
    DateFormat[DateFormat["ShortDateMediumTimeWithFullYear"] = 11] = "ShortDateMediumTimeWithFullYear";
    DateFormat[DateFormat["ShortDateMediumTimeWithFullYear24Hour"] = 12] = "ShortDateMediumTimeWithFullYear24Hour";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var DateInputFieldType;
(function (DateInputFieldType) {
    DateInputFieldType[DateInputFieldType["Line"] = 0] = "Line";
    DateInputFieldType[DateInputFieldType["Outline"] = 1] = "Outline";
})(DateInputFieldType = exports.DateInputFieldType || (exports.DateInputFieldType = {}));
var Shadow = TabStyles_1.TabStyles.Shadow, Colors = TabStyles_1.TabStyles.Colors, Sizing = TabStyles_1.TabStyles.Sizing;
var TextFieldContainerStyleName = TypeStyle.style({ display: 'flex' });
var TextFieldStyle = {
    paddingRight: 24,
    width: '100%',
};
var DialogStyle = {
    boxShadow: Shadow.Standard,
    lineHeight: 'normal',
    outline: 'none',
};
var OverlayAnchorOrigin = { vertical: Overlay_1.VerticalOriginOption.bottom, horizontal: Overlay_1.HorizontalOriginOption.left };
var DateInputField = /** @class */ (function (_super) {
    tslib_1.__extends(DateInputField, _super);
    function DateInputField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputElement = null;
        _this.buttonElement = null;
        _this.overlayElement = null;
        _this.datePickerId = DomUtil_1.generateId();
        _this.state = {
            inputText: undefined,
            isDatePickerOpen: false,
            measuredLabelHeight: 0,
        };
        _this.setLabelHeight = function () {
            _this.setState({ measuredLabelHeight: _this.inputElement.parentElement.offsetTop });
        };
        _this.handleInputRef = function (ref) {
            _this.inputElement = ref;
            if (ref) {
                _this.setLabelHeight();
            }
        };
        _this.handleButtonRef = function (ref) {
            _this.buttonElement = ref;
        };
        _this.handleOverlayRef = function (ref) {
            _this.overlayElement = ref;
        };
        _this.handleButtonClick = function () {
            _this.toggleDatePicker();
        };
        _this.handleInputChange = function (e) {
            var inputText = e.target.value;
            _this.setState({ inputText: inputText });
        };
        _this.handleInputKeyDown = function (e) {
            if (e.key === 'Enter') {
                var parsedDate = Date_1.getParsedDate(e.target.value, _this.props.terminus);
                if (parsedDate) {
                    _this.closeAndConfirm(parsedDate);
                }
            }
            else if (e.key === 'Escape') {
                _this.resetState();
            }
            else if (_this.props.hasDatePicker) {
                switch (e.key) {
                    case ' ':
                        if (_this.inputElement.selectionStart === 0 && _this.inputElement.selectionEnd === _this.inputElement.value.length) {
                            _this.open();
                            break;
                        }
                        return;
                    case 'ArrowDown':
                        _this.open();
                        break;
                    case 'ArrowUp':
                        _this.close();
                        break;
                    default:
                        return;
                }
            }
            else {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
        };
        _this.handleOverlayKeyUp = function (e) {
            if (e.key === 'Escape') {
                _this.resetState();
                e.preventDefault();
            }
            e.stopPropagation();
        };
        _this.handleBlur = function (e) {
            var _a, _b;
            var toElement = DomUtil_1.findBlurRelatedTarget(e);
            if (((_a = _this.buttonElement) === null || _a === void 0 ? void 0 : _a.contains(toElement)) || e.currentTarget.contains(toElement) || ((_b = _this.overlayElement) === null || _b === void 0 ? void 0 : _b.contains(toElement))) {
                return;
            }
            var parsedDate = Date_1.getParsedDate(_this.inputElement.value, _this.props.terminus);
            if (parsedDate && !_this.props.errorText && _this.props.valid !== false) {
                _this.closeAndConfirm(parsedDate);
            }
            else {
                _this.resetState();
            }
        };
        _this.resetState = function () {
            _this.setState({ isDatePickerOpen: false, inputText: undefined });
        };
        _this.handlePickerChange = function (date) {
            var dateWithTerminus = Date_1.getDateWithTerminus(date, Localize_1.Parsers.parseShortDate, _this.props.terminus);
            _this.confirmIfChanged(dateWithTerminus);
        };
        _this.handlePickerConfirm = function (date) {
            _this.closeAndConfirm(date);
        };
        _this.renderDatePicker = function () {
            var datePickerProps = {
                autofocus: true,
                isDateDisabled: _this.props.isDatePickerDateDisabled,
                onChange: _this.handlePickerChange,
                onConfirm: _this.handlePickerConfirm,
                selectedDate: _this.props.selectedDate,
                showWeekNumbers: _this.props.showDatePickerWeekNumbers,
                testId: _this.props.testId + "-date-picker",
            };
            return React.createElement(DatePickerWidget_1.DatePickerWidget, tslib_1.__assign({}, datePickerProps));
        };
        _this.portalEventTrapOverrides = {
            onBlur: _this.handleBlur,
            onKeyUp: _this.handleOverlayKeyUp
        };
        return _this;
    }
    DateInputField.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b, _c;
        var _d = this.state, inputText = _d.inputText, isDatePickerOpen = _d.isDatePickerOpen;
        var _e = this.props, displayFormat = _e.displayFormat, selectedDate = _e.selectedDate;
        // tslint:disable-next-line:max-line-length
        if ((prevProps.valid !== false && this.props.valid === false) || (this.props.errorText && this.props.errorText !== prevProps.errorText)) {
            // close the popup any time the error message is updated to ensure the user can see it (as it is not displayed in the popup)
            this.close();
        }
        if (!isDatePickerOpen && prevState.isDatePickerOpen && this.inputElement && document.body.contains(this.inputElement)) {
            this.inputElement.focus();
        }
        if (prevProps.displayFormat !== displayFormat || prevProps.selectedDate.getTime() !== ((_a = selectedDate) === null || _a === void 0 ? void 0 : _a.getTime())) {
            this.setState({ inputText: undefined });
        }
        else if (inputText !== prevState.inputText) {
            var parsedDate = Date_1.getParsedDate(inputText || '', this.props.terminus);
            if (!parsedDate) {
                this.close(); // if we can't parse it, we can't show it in the DatePicker popup
            }
            // inputText is `undefined` when the state is reset back to initial, but the empty string if the user deletes all the text
            // this is an important distinction when signaling the current state of the field to e.g. external validators
            (_c = (_b = this.props).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, inputText !== undefined ? parsedDate : selectedDate);
        }
        if (prevProps.label !== this.props.label) {
            this.setLabelHeight();
        }
    };
    DateInputField.prototype.open = function () {
        this.toggleDatePicker(true);
    };
    DateInputField.prototype.close = function () {
        this.toggleDatePicker(false);
    };
    DateInputField.prototype.toggleDatePicker = function (open) {
        if (open === void 0) { open = !this.state.isDatePickerOpen; }
        if (!this.props.hasDatePicker || open === this.state.isDatePickerOpen) {
            return;
        }
        this.setState({ isDatePickerOpen: open });
    };
    DateInputField.prototype.confirmIfChanged = function (date) {
        var _a, _b;
        // TODO: ENTER or onBlur on an untouched field triggers a confirm event because the parser strips the time...bug in `getParsedDate`?
        if (date.getTime() !== this.props.selectedDate.getTime()) {
            (_b = (_a = this.props).onConfirm) === null || _b === void 0 ? void 0 : _b.call(_a, date);
        }
        else {
            this.resetState();
        }
    };
    DateInputField.prototype.closeAndConfirm = function (date) {
        this.close();
        this.confirmIfChanged(date);
    };
    DateInputField.prototype.getFormattedDate = function (date) {
        return Date_1.getDateFormatter(this.props.displayFormat)(date);
    };
    DateInputField.prototype.isOutlineTextField = function () {
        return this.props.dateInputFieldType === DateInputFieldType.Outline;
    };
    DateInputField.prototype.renderTextField = function () {
        var _a;
        var hasDatePicker = this.props.hasDatePicker;
        var inputValue = (_a = this.state.inputText, (_a !== null && _a !== void 0 ? _a : this.getFormattedDate(this.props.selectedDate)));
        var parsedDate = Date_1.getParsedDate(inputValue, this.props.terminus);
        var numCols = 7;
        var containerStyle = tslib_1.__assign(tslib_1.__assign({}, this.props.style), { 
            // maxWidth is the width of the picker, because input width cannot be wider than the picker.
            // cell width (30px) * colNum + Spacing.DefaultSpace * 2 + Sizing.BorderWidth * 2
            maxWidth: 30 * numCols + TabStyles_1.TabStyles.Spacing.DefaultSpace * 2 + TabStyles_1.TabStyles.Sizing.BorderWidth * 2, position: 'relative' });
        return (React.createElement("div", { onBlur: this.handleBlur, style: containerStyle },
            React.createElement(SharedWidgets_1.TextFieldWidget, tslib_1.__assign({}, (hasDatePicker && {
                'aria-expanded': !!this.state.isDatePickerOpen,
                'aria-haspopup': 'dialog',
                'aria-controls': (this.state.isDatePickerOpen ? this.datePickerId : undefined),
                role: 'combobox',
            }), { "aria-labelledby": this.props['aria-labelledby'], className: TextFieldContainerStyleName, disabled: this.props.disabled, kind: this.isOutlineTextField() ? 'outline' : 'line', label: this.props.label, 
                // TODO use ZWS? careful of isTruthy/isFalsy tests
                message: this.props.errorText || this.props.message || (!parsedDate ? Localize_1.Messages.enterValidDate() : ''), onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, ref: this.handleInputRef, style: TextFieldStyle, testId: this.props.testId + "-text-field", valid: (!parsedDate || this.props.errorText) ? false : this.props.valid, value: inputValue })),
            hasDatePicker && this.renderDropdownButton()));
    };
    DateInputField.prototype.renderDropdownButton = function () {
        var baseStyle = {
            borderRadius: 0,
            cursor: 'pointer',
            display: 'inline-flex',
            height: Sizing.RowHeight - 2 * Sizing.BorderWidth,
            minWidth: 0,
            position: 'absolute',
            right: 0,
            top: Sizing.BorderWidth + this.state.measuredLabelHeight,
        };
        var outlineStyle = tslib_1.__assign(tslib_1.__assign({}, baseStyle), { borderLeft: "1px solid " + Colors.L3, right: Sizing.BorderWidth });
        var buttonProps = {
            buttonRef: this.handleButtonRef,
            buttonType: SharedWidgets_1.ButtonType.IconOutline,
            disableTabAccessibility: true,
            disabled: this.props.disabled,
            getContent: function (state) { return React.createElement(DomWidgets_1.Img, { draggable: false, src: Icons_1.encodeSvg(Icons_1.DropdownArrowIcon.icon(state)) }); },
            handleClick: this.handleButtonClick,
            style: this.isOutlineTextField() ? outlineStyle : baseStyle,
            testId: this.props.testId,
        };
        return (React.createElement(SharedWidgets_1.ButtonWidget, tslib_1.__assign({}, buttonProps)));
    };
    DateInputField.prototype.renderOverlay = function () {
        var datePicker = this.state.isDatePickerOpen && this.props.hasDatePicker && this.renderDatePicker();
        if (!datePicker || !this.inputElement) {
            return null;
        }
        return (React.createElement(Overlay_1.Overlay, { allowAutoPosition: true, anchorEl: this.inputElement, anchorOrigin: OverlayAnchorOrigin, 
            // tslint:disable-next-line:deprecation
            stackingRootId: this.props.stackingRootId, portalEventTrapOverrides: this.portalEventTrapOverrides, zIndex: this.props.zIndex },
            React.createElement("div", { id: this.datePickerId, ref: this.handleOverlayRef, role: 'dialog', style: DialogStyle, tabIndex: -1 }, datePicker)));
    };
    DateInputField.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": this.props.testId },
            this.renderTextField(),
            this.renderOverlay()));
    };
    // tslint:disable-next-line:max-line-length
    DateInputField.defaultProps = {
        dateInputFieldType: DateInputFieldType.Line,
        displayFormat: DateFormat.ShortDateWithFullYear,
        hasDatePicker: true,
        selectedDate: new Date(),
        showDatePickerWeekNumbers: false,
    };
    return DateInputField;
}(React.Component));
exports.DateInputField = DateInputField;
//# sourceMappingURL=DateInputField.js.map